import { DefaultTheme } from '@emotion/react';

export default {} as DefaultTheme;
